import styled from 'styled-components';
import { handleCheckedBackground, handleCheckedBorder, handleCheckedIcon, handlePressed, } from '../../../../shared/styling/InputRadioCheckbox.helpers';
const BaseInputRadioContainer = styled.div `
  input {
    opacity: 0;
    width: 0;
    height: 0;
    position: absolute;
    left: -9999px;

    &:checked + label:before {
      border-color: ${({ theme, disabled, error }) => handleCheckedBorder(disabled, error, theme)};
      background-color: ${({ theme, disabled, error }) => handleCheckedBackground(disabled, error, theme)};
    }

    &:checked + label:after {
      transform: scale(1);
    }

    &:focus + label::before {
      box-shadow: ${({ theme }) => theme.shadows.small};
    }
  }

  label {
    position: relative;
    display: flex;
    align-items: center;
    height: 20px;
    margin-bottom: 0;
    cursor: pointer;

    &::before,
    &::after {
      position: absolute;
      content: '';
      border-radius: 50%;
      transition: all 0.3s ease;
      transition-property: transform, border-color, box-shadow;
    }

    &::before {
      left: 0;
      top: 0;
      width: 20px;
      height: 20px;
      border: 1px solid
        ${({ theme, error }) => (error ? theme.colors.supportError01 : theme.colors.ui03)};
      background-color: ${({ theme, disabled }) => (disabled ? theme.colors.disabled01 : 'none')};
    }

    &::after {
      top: 6px;
      left: 6px;
      width: 8px;
      height: 8px;
      transform: scale(0);
      background: ${({ theme, disabled, error }) => handleCheckedIcon(disabled, error, theme)};
    }

    &:hover::before {
      box-shadow: ${({ theme, disabled }) => (disabled ? 'none' : theme.shadows.small)};
    }

    ${({ theme, disabled, error }) => handlePressed(disabled, error, theme, true)};
  }

  p,
  label {
    padding-left: 32px;
  }

  ${({ customCss }) => customCss || ''}
`;
export default BaseInputRadioContainer;
//# sourceMappingURL=BaseInputRadioContainer.js.map